var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var ui_extensions = require("ui-extensions");
var cio_datamodel = require("cio-datamodel");

var PathSegmentModel = require("./pathSegmentModel");
var ArcFocalHandleModel = require("./arcFocalHandleModel");
var ArcCenterHandleModel = require("./arcCenterHandleModel");
var cio_config = require("cio-config");

var PathArcSegmentModel = function (pathInteractionModel, object, next_handle, prev_handle) {
    var self = this;
    PathSegmentModel.apply(this, arguments);

    this.movingHandle = this.value('movingHandle', true);

    this.C = this.value( "C", true);
    this.F = this.value( "F", true);
    this.Fp = this.value( "Fp", true);
};
lib_core.inherit(PathArcSegmentModel, PathSegmentModel);
PathArcSegmentModel.$class = "PathArcSegmentModel";
module.exports = PathArcSegmentModel;

PathArcSegmentModel.prototype.initialize = function() {
    var self = this;
    PathSegmentModel.prototype.initialize.call(this);

    // connect changes in datamodel of object (like from inspector) to changes in handle model
    // note we are not using onBubble here because we do not want to
    // update C and F when the endpoint changes
    this.object.xRadius.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);
    this.object.yRadius.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);
    this.object.angle.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);
    this.object.largeArcFlag.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);
    this.object.sweepFlag.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);
    this.object.endpoint.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);
    this.prev_object = this.object.previous();
    this.prev_object.endpoint.onChange(this, function () {
        if(self.isAlive()) { self.resetCandF(); }
    }, 10);

    this.onDie(this, function() {
        self.object.xRadius.removeHandlers(self);
        self.object.yRadius.removeHandlers(self);
        self.object.angle.removeHandlers(self);
        self.object.largeArcFlag.removeHandlers(self);
        self.object.sweepFlag.removeHandlers(self);
        self.object.endpoint.removeHandlers(self);
        self.prev_object.endpoint.removeHandlers(self);
    });

    //create handle models
    var coords = this.object.calculateCandF();
    this.C(new ArcCenterHandleModel(coords.c_coord));
    this.F(new ArcFocalHandleModel("F", coords.f_coord));
    this.Fp(new ArcFocalHandleModel("Fp", coords.fp_coord));

    this.C().otherHandleModel1 = this.F();
    this.C().otherHandleModel2 = this.Fp();
    this.F().otherHandleModel1 = this.C();
    this.F().otherHandleModel2 = this.Fp();
    this.Fp().otherHandleModel1 = this.C();
    this.Fp().otherHandleModel2 = this.F();


    this.isCircular = this.shadow("isCircular",
        function() {
            return Math.abs(self.object.xRadius()-self.object.yRadius()) < 1e-6;
        }, null,
        [[this.object.xRadius, this.object.xRadius.onChange],
        [this.object.yRadius, this.object.yRadius.onChange]]
    );

    // these are the valid focal points
    this.workplane = this.pathInteractionModel.editorModel.cameraModel().workplane;
    this.validFocalPointsCurve = this.shadow("validFocalPointsCurve",
        function () {
            return self.recalculateValidFocusPoints();
        },
        null,
        [
            self.C().coord,
            self.object.endpoint,
            self.object.previous().endpoint,
            this.workplane
        ]
    );

    //Shadows for inspector
    this.origin = this.parent().origin;

    if (this.origin) {
        this.showxRadius = this.shadow("showxRadius",
            function () {
                return self.object.xRadius();
            },
            function (value) {
                return self.object.xRadius(value);
            },
            [this.object.xRadius]
        );

        this.showyRadius = this.shadow("showyRadius",
            function () {
                return self.object.yRadius();
            },
            function (value) {
                return self.object.yRadius(value);
            },
            [this.object.yRadius]
        );

        this.showAngle = this.shadow("showAngle",
            function () {
                return self.object.angle();
            },
            function (value) {
                return self.object.angle(((value%360)+360)%360);
            },
            [this.object.angle]
        );

        this.showArcSide = this.shadow("showArcSide",
            function () {
                return self.object.sweepFlag();
            },
            function (value) {
                var toggle = (!!self.object.sweepFlag()) !== (!!value);
                if(toggle) {
                    return self.object.largeArcFlag(!self.object.largeArcFlag())
                        && self.object.sweepFlag(!self.object.sweepFlag());
                }
            },
            [this.object.largeArcFlag, this.object.sweepFlag]
        );
    }
};

PathArcSegmentModel.prototype.getInspectorElements = function () {
    var inspectorElements = PathSegmentModel.prototype.getInspectorElements.call(this);

    var self = this;

    var gridUnit = this.parent().origin.grid_unit().replace('u','\u03BC');

    inspectorElements.input_elements.splice(3, 0,
        {
            label       : 'Arc xRadius',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showxRadius,
            datatype    : cio_config.types.float,
            unit        : gridUnit
        },
        {
            label       : 'Arc yRadius',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showyRadius,
            datatype    : cio_config.types.float,
            unit        : gridUnit
        },
        {
            label       : 'Arc Angle',
            type        : ui_extensions.InspectorInputType.VALUE_AND_FIXEDUNIT,
            datamember  : this.showAngle,
            datatype    : cio_config.types.float,
            unit        : "°"
        },
        {
            label       : 'Arc Side',
            type: ui_extensions.InspectorInputType.CHECKBOX,
            datamember  : this.showArcSide
        }
        // {
        //     label       : 'Arc Sweep',
        //     type: ui_extensions.InspectorInputType.CHECKBOX,
        //     datamember  : this.object.sweepFlag
        // },
        // {
        //     label       : 'Large Arc',
        //     type: ui_extensions.InspectorInputType.CHECKBOX,
        //     datamember  : this.object.largeArcFlag
        // }
    );

    inspectorElements.help_elements = {
        'name': 'Arc Segment'
    };

    return inspectorElements;
};

PathArcSegmentModel.prototype.beforeMoveStartPoint = function(vec) {
    this.start_move_c_coord = this.C().coord();
    this.start_move_f_coord = this.F().coord();
};

//when moving an endpoint of the arc, move the focal and center point accordingly to keep a similar (but scaled and rotated) arc shape
PathArcSegmentModel.prototype.afterMoveStartPoint = function(vec) {
    var self = this;
    var new_start_coord = self.prev_handle.coord();
    var old_start_coord = new_start_coord.sub(vec);

    var transform_origin = self.next_handle.coord();
    var old_end_start_vec = old_start_coord.sub(transform_origin);
    var new_end_start_vec = new_start_coord.sub(transform_origin);
    function transform(point) {
        if(old_end_start_vec.length() == 0) {
            return new_start_coord.add(transform_origin).mult(1/2);
        } else {
            return point
                .sub(transform_origin)
                .rotate(new_end_start_vec.angleDegrees()-old_end_start_vec.angleDegrees())
                .mult(new_end_start_vec.length()/old_end_start_vec.length())
                .add(transform_origin);
        }
    }
    var new_c = transform(this.start_move_c_coord);
    var new_fp = transform(this.start_move_f_coord);
    this.setApproximateCandF(new_c, new_fp);
    this.start_move_c_coord = null;
    this.start_move_f_coord = null;
};

PathArcSegmentModel.prototype.beforeMoveEndPoint = PathArcSegmentModel.prototype.beforeMoveStartPoint;

PathArcSegmentModel.prototype.afterMoveEndPoint = function(vec) {
    var self = this;
    var new_start_coord = self.next_handle.coord();
    var old_start_coord = new_start_coord.sub(vec);

    var transform_origin = self.prev_handle.coord();
    var old_end_start_vec = old_start_coord.sub(transform_origin);
    var new_end_start_vec = new_start_coord.sub(transform_origin);
    function transform(point) {
        if(old_end_start_vec.length() == 0) {
            return new_start_coord.add(transform_origin).mult(1/2);
        } else {
            return point
                .sub(transform_origin)
                .rotate(new_end_start_vec.angleDegrees()-old_end_start_vec.angleDegrees())
                .mult(new_end_start_vec.length()/old_end_start_vec.length())
                .add(transform_origin);
        }
    }
    var new_c = transform(this.start_move_c_coord);
    var new_fp = transform(this.start_move_f_coord);
    this.setApproximateCandF(new_c, new_fp);
    this.start_move_c_coord = null;
    this.start_move_f_coord = null;
};

//update center and focal point based on rx, ry and angle stored in the datamodel
PathArcSegmentModel.prototype.resetCandF = function() {
    var self = this;
    if (self.isAlive() && self.object.isAlive() && !self.movingHandle()) {
        var res = this.object.calculateCandF();
        self.C().coord(res.c_coord);
        self.F().coord(res.f_coord);
        self.Fp().coord(res.fp_coord);
    }
};

/**
 * This function is used to translate changes in arc handle coordinates (C or F) to
 *   changes in path object data model xRadius, yRadius, and angle.
 * C is applied directly without changes if possible
 * F is snapped to the closest valid focal point
 * @author E.Pataky
 * @function setApproximateCandF
 */
PathArcSegmentModel.prototype.setApproximateCandF = function (c_coord, f_coord) {
    var self = this;
    self.grid_value = this.pathInteractionModel.origin.getGridSpacing();

    //snap c to middle point (to handle numerical instability)
    var middle = this.next_handle.coord().add(this.prev_handle.coord()).mult(1/2);
    if(c_coord.distance(middle) < 1e-6)
        c_coord = middle;

    this.C().coord(c_coord);//not so good
    var fp_coord = f_coord.flip(c_coord);

    var C = this.C().coord();
    var A = this.prev_handle.coord();
    var B = C.add(A.sub(C).mult(-1.0));
    var D = this.next_handle.coord();
    var E = C.add(D.sub(C).mult(-1.0));

    var f_best;
    function arePointsOnSameEllipse(point1, point2, precision) {
        var t1 = point1.distance(f_coord) + point1.distance(fp_coord);
        var t2 = point2.distance(f_coord) + point2.distance(fp_coord);
        return Math.abs(t1-t2) < precision;
    }
    if(arePointsOnSameEllipse(A, D, 1e-6)) {
        f_best = f_coord;
    } else {
        var t_min = Math.max(A.distance(B), D.distance(E)) + 1e-6;
        function binaryFindBestOnCurve(curve_num) {
            var t_best = t_min;
            var f_best_local;
            var t_diff = t_min*20;
            function test_t(t) {
                if(t>=t_min) {
                    var new_f = self.calculateAValidFocalPoint(t, curve_num);
                    var dist_diff = (f_best_local && new_f) ? f_coord.distance(new_f) - f_coord.distance(f_best_local) : 1e6;
                    if(!f_best_local || dist_diff < 0) {
                        t_best = t;
                        f_best_local = new_f;
                    }
                    return dist_diff;
                }
                return 0;
            }
            var dist_diff = 1e6;
            while(dist_diff > 1e-4) {
                var dist_diff1 = test_t(t_best + t_diff);
                var dist_diff2 = test_t(t_best - t_diff);
                dist_diff = Math.max( //update stopping condition
                    Math.abs(dist_diff1),
                    Math.abs(dist_diff2));
                t_diff /= 2;
            }
            if(!f_best || f_best_local && f_coord.distance(f_best_local) < f_coord.distance(f_best)) {
                f_best = f_best_local;
            }
        }
        binaryFindBestOnCurve(0);
        binaryFindBestOnCurve(1);
        binaryFindBestOnCurve(2);
        binaryFindBestOnCurve(3);
    }
    console.assert(f_best);
    console.assert(lib_geometry.Coord.validator(c_coord));
    console.assert(lib_geometry.Coord.validator(f_best));
    this.object.setCandF(c_coord, f_best);

    //set handles
    var fp_best = f_best.flip(c_coord);
    this.C().coord(c_coord);
    this.F().coord(f_best);
    this.Fp().coord(fp_best);
};

function acot(s) {
    if(s  <  0)
        return Math.atan(1 / s) + Math.PI;
    else
        return Math.atan(1 / s);
}

// calculate a valid focal point with parameter t on one of 4 curves
PathArcSegmentModel.prototype.calculateAValidFocalPoint = function (t, curve_num) {
    var C = this.C().coord();
    var A = this.prev_handle.coord();
    var B = A.flip(C);
    var D = this.next_handle.coord();
    var E = D.flip(C);

    var ab = A.distance(B);
    var de = D.distance(E);

    var rx_1 = t/2;
    var ry_1 = Math.sqrt(t*t / 4 - ab*ab / 4);
    var alpha_1 = A.sub(B).angle();
    // var rx_2 = t/2;
    // var ry_2 = Math.sqrt(t*t / 4 - de*de / 4);
    var alpha_2 = D.sub(E).angle();

    //equation from math_focal_points.py parsed with ast_test.py to provide optimised code
    var a1 = Math.sqrt(2);
    var a2 = t * t;
    var a3 = de * de;
    var a7 = a2 / 4;
    var a8 = ((- a3) / 4) + a7;
    var a9 = a2 * a8;
    var a21 = ((- (ab * ab)) / 4) + a7;
    var a26 = Math.sin(((2 * alpha_1) - (2 * alpha_2)));
    var a32 = alpha_1 - alpha_2;
    var a33 = Math.sin(a32);
    var a34 = a33 * a33;
    var a36 = (a2 * a34) / 4;
    var a45 = 1 - a34;
    var a46 = a21 * a45;
    var a61 = (a2 * a45) / 4;
    var a71 = a21 * a34;
    var a74 = ((a2 * (a36 - a46)) / 4) + (a8 * (a61 - a71));
    var a88 = Math.sqrt((((((((a3 * a3) * a2) * a21) * (a26 * a26)) / 64) + (a74 * a74)) / ((a2 * a2) * (a8 * a8))));
    var a116 = (a2 * (a36 + a46)) / 4;
    var a141 = a8 * (a61 + a71);
    var rx_3 = ((a1 * Math.sqrt((a9 / (((((- a2) * a88) * a8) + a116) + a141)))) / 2);
    var ry_3 = ((a1 * Math.sqrt((a9 / ((((a2 * a88) * a8) + a116) + a141)))) / 2);
    var alpha_3 = (acot(((8 * a74) / (((a3 * t) * Math.sqrt(a21)) * a26))) / 2);

    if((((alpha_2-alpha_1)%Math.PI)+Math.PI)%Math.PI > Math.PI/2)//real math modulo
        alpha_3 += Math.PI/2;

    if(rx_3 < 1 && ry_3 < 1)    //no intersection
        return;

    var G = new lib_geometry.Coord(
            rx_3*Math.sqrt(Math.abs((ry_3*ry_3 - 1)/(rx_3*rx_3 - ry_3*ry_3))),
            ry_3*Math.sqrt(Math.abs((rx_3*rx_3 - 1)/(rx_3*rx_3 - ry_3*ry_3)))
        );
    switch(curve_num) {
        case 0:
            break;
        case 1:
            G = G.mult(-1,1);
            break;
        case 2:
            G = G.mult(1,-1);
            break;
        case 3:
            G = G.mult(-1,-1);
            break;
        default:
            throw new Error();
    }

    G = G.rotate(alpha_3/Math.PI*180);
    G = G.mult(rx_1, ry_1);
    G = G.rotate(alpha_1/Math.PI*180);
    G = G.add(C);
    if(!isNaN(G.x) && !isNaN(G.y)) {
        return G;
    }
    return null;
};

PathArcSegmentModel.prototype.recalculateValidFocusPoints = function () {
    var C = this.C().coord();
    var A = this.prev_handle.coord();
    var B = C.add(A.sub(C).mult(-1.0));
    var D = this.next_handle.coord();
    var E = C.add(D.sub(C).mult(-1.0));
    var middle = A.add(D).mult(1/2);
    if(middle.distance(C)<1e-6) //if C is close to middle between A and D every point is a valid focal point and no curves can be drawn
        return null;
    var curvePoints = [];
    var tmin = Math.max(A.distance(B), D.distance(E)) + 1e-6;
    for(var curve_num=0; curve_num<4; curve_num++) {
        var curve = [];
        for(var t=tmin; t<tmin*20; t+=tmin*20/1000) {
            var point = this.calculateAValidFocalPoint(t, curve_num);
            if(point) {
                curve.push(point);
                if(!this.workplane().contains(point))
                    break;
            }
        }
        curvePoints.push(curve);
    }

    return curvePoints;
};

PathArcSegmentModel.prototype.createPathObjectOnSegment = function(coord) {
    var prev_endpoint = this.prev_handle.coord();
    var next_endpoint = this.next_handle.coord();

    //intent is to create two arcs that together are equivalent to the old arc
    var new_object = new cio_datamodel.PathObjectData(coord.copy(), cio_datamodel.PathType.ARC);
    new_object.xRadius(this.object.xRadius());
    new_object.yRadius(this.object.yRadius());
    new_object.angle(this.object.angle());
    new_object.sweepFlag(this.object.sweepFlag());

    //recalculate large arc flags
    var c_coord = this.C().coord();
    var large_arc_flag = this.object.largeArcFlag();
    function isLargeAngle(angle) {
        angle = ((angle % 360) + 360) % 360; //real mod
        return angle > 180;
    }
    var old_angle = next_endpoint.sub(c_coord).angleDegrees() - prev_endpoint.sub(c_coord).angleDegrees();
    var flip_angle = isLargeAngle(old_angle) !== large_arc_flag;
    var angle_new_arc = coord.sub(c_coord).angleDegrees() - prev_endpoint.sub(c_coord).angleDegrees();
    new_object.largeArcFlag(isLargeAngle(angle_new_arc) !== flip_angle);

    var angle_old_arc = next_endpoint.sub(c_coord).angleDegrees() - coord.sub(c_coord).angleDegrees();
    this.object.largeArcFlag(isLargeAngle(angle_old_arc) !== flip_angle);
    return new_object;
};

PathArcSegmentModel.prototype.getSubSnapSet = function (snapSet) {
    var dir_segment = this.next_handle.coord().sub(this.prev_handle.coord());
    var perp_dir = dir_segment.perp();
    var center = this.next_handle.coord().add(this.prev_handle.coord()).mult(1.0/2.0);
    snapSet.add(new lib_geometry.Line(perp_dir.norm(), center), 2, 0, null, this, 0, null);
    var seg = new lib_geometry.Segment(this.prev_handle.coord(), this.next_handle.coord());
    if(!seg.isLengthZero())
        snapSet.add(seg, 2, 0, null, this, 0, "ArcSegmentSegment");
    snapSet.add(this.C().coord(), 2, 1e-6, null, this, 0, null);
};

